import React from "react";

export const SectionRundown = ({ rundown, formatDate }) => (
  <section className="text-cyan-900">
    <div className="overflow-x-auto">
      <table className="w-full table-auto divide-y divide-gray-200">
        <thead>
          <tr className="bg-gray-100">
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
              Rundown
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
              Tanggal
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
              Jam
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
              Lokasi
            </th>
          </tr>
        </thead>
        <tbody>
          {rundown && rundown.length > 0 ? (
            rundown.map((entry, index) => (
              <tr
                key={index}
                className="border-b border-gray-200 hover:bg-gray-50"
              >
                <td className="px-4 py-4 text-sm text-gray-700">
                  {entry.activity || "-"}
                </td>
                <td className="px-4 py-4 text-sm text-gray-700">
                  {formatDate(entry.date)}
                </td>
                <td className="px-4 py-4 text-sm text-gray-700">
                  {entry.time || "-"}
                </td>
                <td className="px-4 py-4 text-sm text-gray-700">
                  {entry.location || "-"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="4"
                className="px-4 py-4 text-sm text-gray-700 text-center"
              >
                Tidak ada data rundown tersedia.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </section>
);
